export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SiteHeader.vue?vue&type=template&id=8e0c3c36&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SiteHeader.vue?vue&type=template&id=8e0c3c36&scoped=true
// module id = 69
// module chunks = 0